import React, { useEffect } from "react";

import { useSelector } from "react-redux";
// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter, useLocation, Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { FlowEmeraldLink } from "./FlowEmeraldLink";

const SidebarContent = ({ type, t }) => {
  let location = useLocation();
  const { data } = useSelector((state) => state.Login);
  useEffect(() => {
    initMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect((prevProps) => {
    if (type !== prevProps && prevProps.type) {
      initMenu();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initMenu = () => {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    let ul = document.getElementById("side-menu");
    let items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  };

  const activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  return (
    <React.Fragment>
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li>
            <Link to="/dashboard">
              <i className="bx bx-home-circle"></i>
              <span>{t("Dashboard")}</span>
            </Link>
          </li>
          {data?.permissions && (
            <>
              <li>
                <Link to="/chats">
                  <i className="bx bx-chat"></i>
                  <span>{t("Agent Panel")}</span>
                </Link>
              </li>
              {data.permissions["manager"] && (
                <li>
                  <Link to="/manager-panel">
                    <i className="bx bx-layout"></i>
                    <span>{t("Manager Panel")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["ticket_panel"] && (
                <li>
                  <Link to="/ticket-panel">
                    <i className="bx bxs-layout"></i>
                    <span>{t("Ticket Panel")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["real_automation"] && (
                <>
                  <li>
                    <FlowEmeraldLink />
                  </li>
                </>
              )}
              {data.permissions["real_cashback"] && (
                <li>
                  <Link
                    to="/real-cashback"
                    target={
                      process.env.REACT_APP_NODE_ENV !== "QA" ? "_blank" : null
                    }
                  >
                    <i className="mdi mdi-cash-multiple"></i>
                    <span>{t("Real CashBack")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["predefined_message"] && (
                <li>
                  <Link to="/predefined-messages">
                    <i className="bx bx-message-square-detail"></i>
                    <span>{t("Predefined Messages")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["scripts"] && (
                <li>
                  <Link to="/scripts">
                    <i className="bx bx-copy-alt"></i>
                    <span>{t("Scripts")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["company"] && (
                <li>
                  <Link to="/company">
                    <i className="bx bx-store"></i>
                    <span>{t("Company")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["department"] && (
                <li>
                  <Link to="/departments">
                    <i className="bx bx-vector"></i>
                    <span>{t("Departments")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["profile"] && (
                <li>
                  <Link to="/profiles">
                    <i className="mdi mdi-account-lock"></i>
                    <span>{t("Profiles")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["user"] && (
                <li>
                  <Link to="/users">
                    <i className="bx bxs-user-detail"></i>
                    <span>{t("Users")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["group"] && (
                <li>
                  <Link to="/groups">
                    <i className="bx bx-group"></i>
                    <span>{t("Groups")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["source"] && (
                <li>
                  <Link to="/channels">
                    <i className="bx bx-devices"></i>
                    <span>{t("Channels")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["skill"] && (
                <li>
                  <Link to="/skills">
                    <i className="bx bx-bookmark"></i>
                    <span>{t("Skills")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["exception"] && (
                <li>
                  <Link to="/exceptions">
                    <i className="mdi mdi-calendar-remove-outline"></i>
                    <span>{t("Exception")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["availabilities"] && (
                <li>
                  <Link to="/availabilities">
                    <i className="bx bxs-toggle-right"></i>
                    <span>{t("Availabilities")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["tabs"] && (
                <li>
                  <Link to="/tabs">
                    <i className="mdi mdi-table"></i>
                    <span>{t("Tabs")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["survey"] && (
                <li>
                  <Link to="/surveys">
                    <i className="mdi mdi-text-box-search-outline"></i>
                    <span>{t("Survey")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["automatic-messages"] && (
                <li>
                  <Link to="/automatic-messages">
                    <i className="mdi mdi-message-arrow-right-outline"></i>
                    <span>{t("Automatic Messages")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["feature"] && (
                <li>
                  <Link to="/features">
                    <i className="bx bxs-widget"></i>
                    <span>{t("Features")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["additional_fields"] && (
                <li>
                  <Link to="/additional-fields">
                    <i className="bx bx-layer-plus"></i>
                    <span>{t("Additional Fields")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["mural"] && (
                <li>
                  <Link to="/murals">
                    <i className="mdi mdi-view-dashboard"></i>
                    <span>{t("Murals")}</span>
                  </Link>
                </li>
              )}
              {data.permissions["goal"] && (
                <li>
                  <Link to="/goals">
                    <i className="mdi mdi-target"></i>
                    <span>{t("Goals")}</span>
                  </Link>
                </li>
              )}
              {/* {data.permissions["reports"] && (
                <li>
                  <Link to="/reports">
                    <i className="bx bxs-report"></i>
                    <span>{t("Reports")}</span>
                  </Link>
                </li>
              )} */}
            </>
          )}
        </ul>
      </div>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(SidebarContent));
